import { SectionCreate } from './SectionCreate';
import { SectionEdit } from './SectionEdit';
import { SectionList } from './SectionList';

export default {
    create: SectionCreate,
    edit: SectionEdit,
    list: SectionList
}
